__turbopack_context__.v({
  "address": "styles-module__YuoB_W__address",
  "infoEntityWrap": "styles-module__YuoB_W__infoEntityWrap",
  "like": "styles-module__YuoB_W__like",
  "mainPrice": "styles-module__YuoB_W__mainPrice",
});
